import React,{ FormEvent, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { API_URL } from "../utils/utility";
import axios from 'axios'
import { data } from "jquery";
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
function BespokeSolutions() {
    const [country, setCountry] = useState([])
    const API = 'https://www.indianarmour.com/indianarmourcms/APIs/Contactus/country.php';
    const fetchPost = () => {
      fetch(API)
        .then((res) => res.json())
        .then((res) => {
          console.log(res)
          setCountry(res)
        })
    }
    useEffect(() => {
      fetchPost()
    }, [])
  
  
  
  
    const navigate = useNavigate();
    const [info, setInfo] = useState({
        type: "message",
        body: "",
      });
  
    const SaveData = async (END_POINT , body ) => {
      console.log(END_POINT, body);
      var response = await axios.post( END_POINT, body);
      console.log(response)
      return { data: response.data, message: response.message, status: response.status || response.statusCode, errors: response.errors };
    };
  
    const { register, handleSubmit, formState: { errors }} = useForm();
    const onSubmit = async(values) => {
      
      console.log(values)
     
      try {
        let apiRes = null;
      
    
    
          apiRes = await SaveData(`${API_URL}/APIs/Contactus/index.php`, {
            ...values 
             
          });
       console.log(apiRes.status)
        if (apiRes.status == 200 && apiRes.data[0].Status == "True") {
          setInfo({ type: "message", body: "Form Submitted Successfully!" });
        //  setsubmitdisable(true)
         
        navigate(`/Thankyou`);
        } else if(apiRes.data[0].Status == "False") {
          
          setInfo({ type: "error", body: "Something went wrong. Please try again!" });
          // throw new Error(apiRes.errors);
        }
      } catch (err) {
        setInfo({ type: "error", body: err.message });
      } 
      // finally {
      //   setApiStatus({ ...apiStatus, inProgress: false });
      // }
    
    };
    return (
        <>
    <Helmet>
        <title>Customized Armor Solutions | Bespoke Body Armor by Indian Armour </title>
        <meta name="description" content="Explore our Bespoke Solutions page for military body armour at Indian Armour. Elevate your defense capabilities with tailored armour solutions crafted for precision and performance." />
        <link rel="canonical" href="https://www.indianarmour.com/bespoke-solutions" />
      </Helmet>
            <section className="inner-banner d-flex align-items-center justify-content-center" style={{ backgroundImage: 'url("/images/bespoke-solutions-banner.png")' }}>
                <div className="inner-banner-content1">
                    <div className="container">
                        <h1 className=" fw-bolder">Size Guide</h1>
                        <strong>Tailored Protection for Solid Performance</strong>
                    </div>
                </div>
            </section>

            <section className="breadcrumb-inner pt-3  pb-5">
                <div className="container">
                    <nav >
                        <ol className="breadcrumb mb-0 justify-content-start">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Size Guide</li>
                        </ol>
                    </nav>
                </div>
            </section>


            <section className='page-content pb-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                          <p>When choosing ballistic protection gear, ensuring the right fit can go a long way in providing maximum comfort and protection. A well-fitting ballistic vest or helmet not only allows better mobility but also ensures maximum safety by covering critical areas.</p>
                          <p>At Indian Armour, we have expertise in providing tailor-fit ballistic protection gear to accommodate different body types and preferences. Here are the key considerations to ensure that your ballistic vest and helmet fit perfectly.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-pink py-70 benefits-bespoke-solution">
               <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2><strong>Ballistic Vests: Getting the Right Fit</strong></h2>
                        <p>Size also influences the weight of the ballistic vest. Larger vests generally weigh more because they have larger coverage areas and contain more protective materials. While weight is essential for protection, comfort should never be compromised.
                        </p>
                        <p>At Indian Armour, we use lightweight durable materials to ensure that all our vests, regardless of size, offer the ideal balance between protection and comfort.</p>

                        <h2 className="mt-4"><strong>Ballistic Helmets: Size and Fit Guide</strong>  </h2>
                       <p>Helmets are designed to protect your head from ballistic impacts, making a secure and comfortable fit important. A helmet that is too large or small won’t provide the necessary protection and can affect your performance in critical situations.</p>
                       <h4 className="mt-4">Measure your Head Circumference</h4>
                       <p>To find the right size helmet, start by measuring the circumference of your head. Use a measuring tape around the widest part of your head, typically about one inch above your eyebrows. This measurement will help you find the appropriate helmet size.</p>
                      <p>Indian Armour helmets typically come in standard sizes ranging from Small to Extra Large (S to XL). These sizes are based on head circumference, so refer to the size chart to match your measurement to the correct size.</p>
                      <h4 className="mt-4">Check for Proper Coverage</h4>
                      <p>The basic rule is that a ballistic helmet should cover the top, sides, front, and back of your head without obstructing your field of vision. The extent of coverage will differ based on the type of helmets chosen such as PASGT, MICH, Mid-Cut, etc.</p>
                    </div>
                </div>
               </div>
            </section> 

             <section className="py-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4"><div className="vertical-integration"><img src="images/vertical-integration.jpg" alt="" className='img-fluid' /></div></div>
                        <div className="col-lg-8">
                            <h3><strong>Ensure a Snug Fit</strong> </h3>
                            <p>Helmets often come with padding or adjustable suspension systems that allow for a customizable fit. Once the helmet is on, it should feel snug but not too tight. You should be able to shake your head gently without the helmet shifting. A helmet that moves around too easily is too big and won’t provide adequate protection.</p>
                            <p>Adjustable straps can help secure the helmet in place. At Indian Armour, our helmets come with high-quality strap systems that ensure a snug and secure fit while providing comfort during extended use.</p>
                        </div>
                    </div>
                </div>
            </section>

              <section className="bg-pink weight-considerations py-70">
                <div className="container">
                    <div className="row mobile-col-reverse">                        
                        <div className="col-lg-8">
                            <h3><strong>Weight Considerations</strong> </h3>
                            <p>Like ballistic vests, the size of a helmet influences its weight. A larger helmet might weigh slightly more due to the additional protective material. The use of accessories like communication devices and night
                            vision goggles also impart additional weight to the helmet.</p>
                            <p>The lightweight materials that we use for our helmets at Indian Armour distribute the weight evenly across your head, reducing strain on your neck and shoulders.</p>
                        </div>
                        <div className="col-lg-4"><div className="vertical-integration"><img src="images/weight-considerations.svg" alt="" className='img-fluid weight-considerations-img' /></div></div>
                    </div>
                </div>
            </section>


         


            <section className="py-70  bg-black perfect-fit">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-white">
                            <h2 className='font-42 d-flex align-items-center  mb-5'><strong>Perfect Fit, Maximum Protection: Choose the Right Gear for Optimal Safety</strong> <img src="/images/ok.svg" alt="" class="ms-3 clock-img" /></h2>
                            <p className="text-white">Choosing the right size for your ballistic vest and helmet is essential for both protection and comfort. A properly fitted vest will cover your vital organs without restricting your movements, while a well-fitted helmet will protect your head while allowing you to move freely.
                            </p>
                            <p className="text-white">
                           At Indian Armour, we offer a comprehensive size range for your perfect fit. If you need further assistance, our team is always available to help you choose the right gear. Remember, the right fit can make all the difference in the field

                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-70 vi-contact" style={{ backgroundImage: 'url("/images/vertical-integration-contact.jpg")' }}>
        <div className="container">
          <h2 className="font-42"><strong>Contact Us Now</strong></h2>
          <div className="row">
            <div className="col-lg-6">
              <img src="/images/vi-contact-img.png" alt="" className="img-fluid"/>
            </div>
            <div className="col-lg-6">
              <div className="contact-us-right">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Full Name *"
                    onInput={(e) => e.target.value = e.target.value.replace(/[^\w\s]/gi, "")}
            
                    {...register("name", { required: true })}
                  />
                  {errors.name && <span className='error'>Full Name is required</span>}
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email Address *"
                    {...register("email", { required: true })}
                  />
                   {errors.email && <span className='error'>Email Address is required</span>}
                </div>
                <div className=" mb-3 position-relative mobile-number">
                  {/* <span className="p-number">+91</span> */}
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Mobile Number *"
                    onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                    {...register("mobile", {  required: false})}
                  />
                  {errors.mobile && <span className='error'>Phone Number required</span>}
                </div>

                <div className=" mb-3 position-relative country">
                  
                   <select className="form-control" {...register("country", {  required: true})}>
                   <option value="">Select Country</option>
                   {country.map((item) => (
                        
                        <option value={item.name}>{item.name}</option>
                        
                        ))}
                   
                   </select>
                 
                   {errors.country && <span className='error'>Country required</span>}
                </div>
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    placeholder="Message"
                    defaultValue={""}
                    {...register("message", { required: true })}
                  />
                   {errors.message && <span className='error'>Message is required</span>}
                </div>
                <div className="input-group justify-content-center mt-5">
                  <button className="btn know-more-btn submit">
                    Submit
                    <span className="input-group-text">
                      <img src="/images/arrow.svg" />
                    </span>
                  </button>
                </div>
              </form>
              </div>
            </div>
          </div>
        </div>
      </section>



        </>
    )
}

export default BespokeSolutions